import { connect } from 'react-redux';

import { Environment } from 'dashboard/models/environment';
import { RootState } from 'dashboard/redux/store';
import DashboardApiRateLimitsView from 'dashboard/views/DashboardApiRateLimitsView';

interface DashboardApiRateLimitsRouteProps {
  currentEnvironment: Environment;
}

const DashboardApiRateLimitsRoute = (props: DashboardApiRateLimitsRouteProps) => {
  return <DashboardApiRateLimitsView currentEnvironment={props.currentEnvironment} />;
};

const mapStateToProps = (state: RootState) => {
  return {
    currentEnvironment: state.currentEnvironment.currentEnvironment,
  };
};

export default connect(mapStateToProps)(DashboardApiRateLimitsRoute);
